exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd[data-v-12e6ee3a] {\n    vertical-align: top;\n}\n.fc-event[data-v-12e6ee3a]{\n    cursor: pointer;\n}\ndiv.container_note[data-v-12e6ee3a] {\n    overflow-wrap: break-word;\n}\ndiv.container_note span[data-v-12e6ee3a] {\n    font-size: 14px;\n    padding: .5rem .5rem .5rem 0;\n}\ndiv.container_note p[data-v-12e6ee3a] {\n    margin-top: 0.5rem;\n    background-color: #f5f5f5;\n    padding:10px;\n}\n", ""]);

// exports
